import React, { useRef, useState, useEffect } from 'react'
import { MoContainer, MoLink, MoModal, MoSpan, MoTextArea, BlockScroller, Input, Alert, Button, ButtonTypes, Flag, Title, Statement } from '../../Mo7/mo7UI'
import { cols, icons } from '../../services/design.sevice';
import { database } from '../../firebase';
import { useAuth } from '../../context/AuthContext';
import { useBoltData } from '../../context/TutorBoltDataContext';
import { useHistory, useParams } from 'react-router-dom';
import { config, useSpring, useTrail } from '@react-spring/core';
import { animated } from '@react-spring/web';
import LocationPicker from "react-leaflet-location-picker";


export default function EditAnnouncement() {
    const { currentUser, sendVerificationEmail } = useAuth()
    const history = useHistory()

    const [error, setError] = useState("")
    const [modalSuccess, setModalSuccess] = useState("")
    const [loading, setLoading] = useState(false)
    const [{ headline, subject, tutoringAdress, groupChatLabel, courseTypes, price, CV }, setAnouncement] = useState({ CV: "", groupChatLabel: "", headline: "", subject: "Design", tutoringAdress: "", courseTypes: [], price: 1 })
    const [subSubjects, setSubSubjects] = useState([])
    const [toggleModal, setToggleModal] = useState(false)

    const { announcement_id } = useParams()

    //#region  data from db
    const { subjectList, courseTypeList } = useBoltData()
    //#endregion

    //#region dom Refs

    const refSetSubjects = useRef()
    const refSetHeadline = useRef()
    const refSetCourseTypes = useRef()
    const refTutoringAdress = useRef()
    const refCV = useRef()
    const refPrice = useRef()
    //#endregion

    useEffect(() => {
        if (!currentUser.emailVerified) setToggleModal(true)
    }, [currentUser.emailVerified])

    useEffect(() => {
        if (announcement_id !== "create") {
            //get doc with this id
            return database.announcements.doc(announcement_id).get().then((doc_or) => {
                if (doc_or.exists) {
                    var doc = database.formattedDoc(doc_or)
                    var new_state = {
                        CV: doc.CV,
                        headline: doc.headline,
                        subject: doc.subject,
                        groupChatLabel: doc.groupChatLabel,
                        tutoringAdress: doc.tutoringAdress,
                        courseTypes: [...doc.courseTypes],
                        price: doc.price
                    }
                    setAnouncement(new_state)
                    setSubSubjects(doc.subSubjects)
                } else {
                    // doc.data() will be undefined in this case
                    console.log("No such document!");
                }
            }).catch((error) => {
                console.log("Error getting document:", error);
            });


        }

    }, [announcement_id])


    //#region Logic
    function addLocationToDatabase() {
        database.doc_data_locations.update({
            [`list.${tutoringAdress.toLowerCase()}`]: true
        })
    }

    async function handleDeleteAnnouncement(e) {
        setError("")
        setLoading(true)
        e.preventDefault()
        var success = false
        try {
            await database.announcements.doc(announcement_id).delete()
            success = true
        } catch (e) {
            setError("Failed to Delete Announcement" + e)
            success = false
        }
        if (success) {
            history.push("/dashboard/announcements")
        } else {
            setLoading(false)
        }
    }
    async function handleAddAnnouncement(e, isOnline) {
        e.preventDefault()
        setError("")
        if (headline.length <= 0) {
            setError("❌ Headline Should not be empty")
            handleScrollToBlock(1)
            return console.log("error submitting");
        }
        if (groupChatLabel.length <= 0) {
            setError("❌ Group Chat Label Should not be empty")
            handleScrollToBlock(1)
            return console.log("error submitting");
        }
        if (headline.length > 100) {
            setError("❌ Headline Should not be this Long ! max : 100 character")
            handleScrollToBlock(1)
            return console.log("error submitting");
        }
        if (courseTypes.length <= 0) {
            setError("❌ Select Course Type")
            handleScrollToBlock(2)
            return console.log("error submitting");
        }
        if (tutoringAdress.length <= 0) {
            setError("❌ tutoring Adress Should not be empty")
            handleScrollToBlock(3)
            return console.log("error submitting");
        }
        if (tutoringAdress.length > 100) {
            setError("❌ tutoring Adress Should not be this long ! : 100 character")
            handleScrollToBlock(3)
            return console.log("error submitting");
        }
        if (CV.length > 400) {
            setError("❌ CV Should not be this long ! : 400 character")
            handleScrollToBlock(3)
            return console.log("error submitting");
        }


        var success = false;

        try {
            setLoading(true)
            if (announcement_id !== "create") {
                await database.announcements.doc(announcement_id).update({
                    uid: currentUser.uid,
                    displayName: currentUser.displayName,
                    subject: subject,
                    subSubjects: subSubjects,
                    groupChatLabel: groupChatLabel,
                    courseTypes: courseTypes,
                    headline: headline,
                    tutoringAdress: tutoringAdress.toLowerCase(),
                    price: price,
                    subscribers: {},
                    photoURL: currentUser.photoURL,
                    isOnline: isOnline,
                    CV: CV,
                    createdAt: database.getCurrentTimeStamp()
                })
            } else {

                await database.announcements.add({
                    uid: currentUser.uid,
                    displayName: currentUser.displayName,
                    subject: subject,
                    groupChatLabel: groupChatLabel,
                    subSubjects: subSubjects,
                    courseTypes: courseTypes,
                    headline: headline,
                    tutoringAdress: tutoringAdress.toLowerCase(),
                    price: parseFloat(price),
                    subscribers: {},
                    photoURL: currentUser.photoURL,
                    isOnline: isOnline,
                    CV: CV,
                    createdAt: database.getCurrentTimeStamp()
                })
            }
            success = true
            addLocationToDatabase()

        } catch (e) {
            setError("Failed to Create Announcement" + e)
            success = false
        }
        if (success) {
            history.push("/dashboard/announcements")
        } else {
            setLoading(false)
        }
    }



    function handleSetAnnouncement(name, value) {
        setAnouncement(prev => ({
            ...prev, [name]: value
        }))
    }

    function handleScrollToBlock(index) {
        switch (index) {
            case 0:
                refSetSubjects.current?.scrollIntoView({ behavior: "smooth" })
                break;
            case 1:
                refSetHeadline.current?.scrollIntoView({ behavior: "smooth" })
                break;
            case 2:
                refSetCourseTypes.current?.scrollIntoView({ behavior: "smooth" })
                break;
            case 3:
                refTutoringAdress.current?.scrollIntoView({ behavior: "smooth" })
                break;
            case 4:
                refCV.current?.scrollIntoView({ behavior: "smooth" })
                break;
            case 5:
                refPrice.current?.scrollIntoView({ behavior: "smooth" })
                break;

            default:
                break;
        }
    }
    //#endregion




    //#region dom generation

    
    //animations
    const anim_subjects = useTrail(
        Object.entries(subjectList).length,
        {
            from: {
                transform: "scale(0)"

            },
            to: {
                transform: "scale(1)"

            }
        })
    const anim_subSubjects = useSpring({
        from:{
            transform: "scale(0)"
        },
        to:{
            transform: "scale(1)"
        }
    })

    

    const domSubjects = Object.entries(subjectList).map((arr,i) => {
        return <animated.div key={i}  style={anim_subjects[i]} ><Flag h='fit-content' text={arr[0]} onClick={function () { handleSetAnnouncement("subject", arr[0]); setSubSubjects([]) }} isActive={subject === arr[0]} /></animated.div>
    })
    const domSubSubjects = Object.entries(subjectList).map(arr => {
        return arr[0] === subject && Object.entries(arr[1].sub).map(sub_arr => {
            return <animated.div key={sub_arr[0]} style={anim_subSubjects} ><Flag h='fit-content' text={sub_arr[0]} onClick={function () {
                var new_arr;
                if (subSubjects.includes(sub_arr[0])) {
                    new_arr = subSubjects.filter(r => r !== sub_arr[0])
                    setSubSubjects(new_arr)
                    return
                }
                if (subSubjects.length >= 8) return;
                new_arr = [...subSubjects]
                new_arr.push(sub_arr[0])
                setSubSubjects(new_arr)

            }}  isActive={subSubjects.includes(sub_arr[0])} /></animated.div>
        })
    })
    const domCourseTypes = Object.entries(courseTypeList).map(arr => {
        return <Flag text={arr[0]} onClick={function () {
            var new_arr;
            if (courseTypes.includes(arr[0])) {
                new_arr = courseTypes.filter(r => r !== arr[0])
                handleSetAnnouncement("courseTypes", new_arr)
                return
            }
            new_arr = [...courseTypes]
            new_arr.push(arr[0])
            handleSetAnnouncement("courseTypes", new_arr)

        }} key={arr[1]} isActive={courseTypes.includes(arr[0])} />
    })



    //#endregion

    const styles = useSpring({

        top: toggleModal ? "0" : "-10rem",
        transform: toggleModal ? "scale(1)" : "scale(0)",
        config: config.gentle
    })


    return (

        <MoContainer>
            <MoContainer w="100vw" pos="absolute" z="999">
                {toggleModal && <animated.div style={styles}>
                    <MoModal suc_message={modalSuccess} message="You have to verify your email, Send verification Link ?" onOk={function () {

                        if (!currentUser.emailVerified) {
                            sendVerificationEmail()
                            setModalSuccess("Check your email !")
                            setTimeout(() => {
                                history.push("/dashboard/home")
                            }, 3000);
                        }

                    }} onClose={function () { history.push("/dashboard/home") }} onCancel={function () { history.push("/dashboard/home") }} />
                </animated.div>}
            </MoContainer>

            {/* Header */}
            <MoContainer h="5rem" flex align="center">
                <MoLink to='/dashboard/announcements'> <MoContainer hvr={"background-color:" + cols.mainDark_2 + ";"} tra="background-color .2s;" sdw={{ x: "10px", y: "10px", sprd: "10px", op: 'rgba(0,0,0,0.25)' }} b_r={{ all: "1rem" }} bg={cols.mainLight_1} grid place="center" wh="4rem">
                    <img width="25px" src={icons.ic_list} alt="" />
                </MoContainer>
                </MoLink>
                <MoSpan fs_mid m_r="auto" m_l="auto"> {announcement_id !== "create" ? "Update" : "Create"} Announcement </MoSpan>
            </MoContainer>
            {/* Subjects */}
            <MoContainer ref={refSetSubjects} pos="relative" h="calc(100vh - 5rem)">
                <BlockScroller next b_offset={4} onClick={function () { handleScrollToBlock(1) }} />
                {/* select subject */}
                <MoContainer m_t="4rem" flex flex_dir_c pd={{ r: "1rem" }}>
                    <Title text='👉 I Give Courses In :' />
                    <MoContainer min_h="5rem" scroller flow_y="scroll" flow_x="hidden" flex wrap="wrap" max_h="8rem" pd={{ t: "1rem", b: "1rem", r: "0", l: ".5rem" }}>
                        {/* flag */}
                        {domSubjects}
                    </MoContainer>
                </MoContainer>
                {/* select sub subject */}
                <MoContainer m_t="4rem" flex flex_dir_c pd={{ r: "1rem" }}>
                    <Title text={`➕ Additional Skills : ( ${subSubjects.length < 8 ? subSubjects.length : "Limit is 8"} )`} />
                    <MoContainer min_h="5rem" scroller flow_y="scroll" flow_x="hidden" flex wrap="wrap" max_h="8rem" pd={{ t: "1rem", b: "1rem", r: "0", l: ".5rem" }}>
                        {/* flag */}
                        {domSubSubjects}
                    </MoContainer>
                </MoContainer>
            </MoContainer>

            {/* Headline */}
            <MoContainer ref={refSetHeadline} pos="relative" h="100vh">
                <BlockScroller prev onClick={function () { handleScrollToBlock(0) }} />
                <BlockScroller next onClick={function () { handleScrollToBlock(2) }} />
                <MoContainer flex flex_dir_c h="70%" pd={{ r: "1rem" }}>
                    <Title text="📰 Create A Headline That Will Attract Students !" />
                    <MoContainer grid place="center" h="50%" pd={{ t: "1rem", b: "1rem", r: "0", l: ".5rem" }}>
                        <Input value={headline} onChange={function (e) {
                            handleSetAnnouncement("headline", e.target.value)
                        }} w="70%" pholder="Your headline !" />
                        <MoContainer grid place="center">
                            <MoSpan fs_sml col={cols.green} > Write A Label For Group Chat Assosiated With This Announcement</MoSpan>
                            <Input value={groupChatLabel} onChange={function (e) {
                                handleSetAnnouncement("groupChatLabel", e.target.value)
                            }} w="50%" pholder="ex : class B2" />
                        </MoContainer>
                    </MoContainer>

                    <Statement text="Headline should be carefully worded to catch someone's eye and get that person interested in reading what follows the headline" w="80%" />
                </MoContainer>
            </MoContainer>

            {/* Courses Types */}
            <MoContainer ref={refSetCourseTypes} pos="relative" h="100vh">
                <BlockScroller prev onClick={function () { handleScrollToBlock(1) }} />
                <BlockScroller next onClick={function () { handleScrollToBlock(3) }} />

                {/* select sub subject */}
                <MoContainer flex flex_dir_c pd={{ r: "1rem" }}>
                    <Title text="🕹️ My Courses Are :" />
                    <MoContainer min_h="5rem" scroller flow_y="scroll" flow_x="hidden" flex wrap="wrap" max_h="8rem" pd={{ t: "1rem", b: "1rem", r: "0", l: ".5rem" }}>
                        {/* flag */}
                        {domCourseTypes}

                    </MoContainer>
                    <Statement text="You can Choose Multiple Ones !" w="80%" />
                </MoContainer>
            </MoContainer>


            {/* Tutorign Adress */}
            <MoContainer ref={refTutoringAdress} pos="relative" h="100vh">

                <BlockScroller prev onClick={function () { handleScrollToBlock(2) }} />
                <BlockScroller next onClick={function () { handleScrollToBlock(4) }} />
                <MoContainer flex flex_dir_c h="85%" pd={{ r: "1rem" }}>
                    <Title text="🗺️ I Give Courses At :" />
                    {/* AIzaSyBnMTp5X4W3uuzd28aRSfuyX4Jrlr3tly8 */}
                    <LocationPicker showControls={false} />
                    <MoContainer grid place="center" pd={{ t: "1rem", b: "1rem", r: "0", l: ".5rem" }}>
                        <Input value={tutoringAdress} onChange={function (e) {
                            handleSetAnnouncement("tutoringAdress", e.target.value)
                        }} w="70%" pholder="Location ... !" />
                    </MoContainer>

                    <Statement text="The map will help ,You still need to type in the adress !" w="80%" />
                </MoContainer>
            </MoContainer>

            {/* CV */}
            <MoContainer ref={refCV} pos="relative" h="100vh">
                <BlockScroller prev onClick={function () { handleScrollToBlock(3) }} />
                <BlockScroller next onClick={function () { handleScrollToBlock(5) }} />
                <MoContainer flex flex_dir_c gap="2rem" h="70%" pd={{ r: "1rem" }}>
                    <Title text="🎓 My CV (Optional But Advised) :" />
                    <MoContainer grid place="center" h="50%" pd={{ t: "1rem", b: "1rem", r: "0", l: ".5rem" }}>
                        <MoTextArea value={CV} onChange={function (e) {
                            handleSetAnnouncement("CV", e.target.value)

                        }} w="80%" h="15rem"
                            pholder="I Have A Degree In ..."
                        />
                    </MoContainer>

                    <Statement text="Include All Of Your Deplomas ,Degrees ,Skills ...." w="80%" />
                </MoContainer>
            </MoContainer>

            {/* Price */}
            <MoContainer ref={refPrice} pos="relative" h="100vh">
                <BlockScroller prev onClick={function () { handleScrollToBlock(4) }} />
                <MoContainer flex flex_dir_c h="70%" pd={{ r: "1rem" }}>
                    <Title text="🤑 Price :" />
                    <MoContainer flex justify="center" align="center" h="50%" pd={{ t: "1rem", b: "1rem", r: "0", l: ".5rem" }}>
                        <Input type="number" min={1} max={999} value={price} onChange={function (e) {
                            handleSetAnnouncement("price", e.target.value)

                        }} w="40%" pholder="💲 ex: 25" />
                        <MoSpan fs_sml > $/Hour </MoSpan>
                    </MoContainer>
                    <MoContainer flex justify="center" align="center" h="50%" pd={{ t: "1rem", b: "1rem", r: "0", l: ".5rem" }}>
                        <MoSpan fs_sml col="black">Average Rate for <MoSpan fs_sml>{subject}</MoSpan> Is <MoSpan>{subjectList[subject]?.avgPrice}</MoSpan> $/Hour</MoSpan>
                    </MoContainer>
                    <Statement text="Decide On A Good Price ! " w="80%" />
                </MoContainer>
                <MoContainer flex align="center" wrap="wrap" justify='center'>
                    <Button disabled={loading} onClick={function (e) {
                        handleAddAnnouncement(e, true)
                    }} type={ButtonTypes.success} title={announcement_id !== "create" ? "Update And Publish !" : "Publish Now !"} m_t="5rem" w="15rem" />

                    <Button disabled={loading} onClick={function (e) {
                        handleAddAnnouncement(e, false)
                    }} type={ButtonTypes.disabled} title={announcement_id !== "create" ? "Update And Publish Later !" : "Save And Publish Later !"} min_w="15rem" m_t="5rem" />

                    {/* Delete announcement */}
                    {announcement_id !== "create" &&
                        <Button disabled={loading} onClick={handleDeleteAnnouncement} type={ButtonTypes.danger} title='Delete !' w="15rem" m_t="5rem" />
                    }
                </MoContainer>
                <MoContainer grid place="center">
                    {error && <Alert danger>{error}</Alert>}
                </MoContainer>
            </MoContainer>
            {/* Finish */}

        </MoContainer >

    )
}
